import { InlineNotification } from '@hologram-dimension/inline-notification';
import { Modal } from '@hologram-dimension/modal';
import orgPickerImg from 'assets/img/new_org/illustration/org_picker.webp?w=360&h=247&imagetools';
import BorderlessPanel from 'components/BorderlessPanel/BorderlessPanel';
import Picture from 'components/Picture/Picture';
import { useState, type FC } from 'react';
import type { CommonModalProps } from '../shared';
import styles from './OrgIntro.module.css';

interface OrgIntroProps extends CommonModalProps {
  orgName: string;
}

const OrgIntro: FC<OrgIntroProps> = ({ onClose, orgName, defaultOpen = false, className }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Modal
      className={className}
      noContentPadding
      header={`Welcome to your ${orgName} dashboard`}
      onClosed={onClose}
      open={open}
      setOpen={setOpen}
    >
      <BorderlessPanel
        headerContents={
          <div className={styles.headerContentsWrapper}>
            <p>
              Your new <span className={styles.orgNameHighlight}>{orgName}</span> dashboard is ready
              to use. Now you can activate your first SIM cards and invite your team to collaborate.
            </p>
            <p>Let’s get you connected.</p>
          </div>
        }
        headerClassName={styles.header}
        contentsClassName={styles.contents}
      >
        <div className={styles.contentsWrapper}>
          <div className={styles.illustration}>
            <Picture image={orgPickerImg} alt="" />
          </div>
          <InlineNotification variant="note">
            You can switch to other organizations using the menu in the upper-right corner of the
            screen.
          </InlineNotification>
        </div>
      </BorderlessPanel>
    </Modal>
  );
};

export default OrgIntro;
